import { getEmployeeProfileServicesConfig } from '@api/company-policy';
import { useQuery } from '@tanstack/react-query';

export const useGetGeneralConfig = () => {
  const {
    data: generalConfigData,
    isLoading: isGeneralConfigLoading,
    refetch: refetchGeneralConfigData,
  } = useQuery({
    queryKey: ['employees-profile', 'general-config'],
    queryFn: () => getEmployeeProfileServicesConfig(),
  });

  return {
    refetchGeneralConfigData,
    isGeneralConfigLoading,
    generalConfigData,
  };
};
